import React from "react"

import { Default, Error, Success, Waiting } from "./Status.styled"

type Props = {
  status: string
}

const successStatuses = new Set([
  "SETTLED",
  "PENDING_MERCHANT_CAPTURE",
  "COMPLETED",
  "Completed",
  "completed",
  "SUCCESS",
  "Success",
  "ACCEPTED",
  "AUTHORIZED",
  "RESERVED",
  "ACTIVE",
  "Active",
  "authorized",
  "ENABLED",
  "Enabled",
  "NOT ARCHIVED",
  "No",
  "REDEEMED",
  "CONFIRMED",
  "Confirmed",
  "Verified",
  "Provided",
  "Required",
  "PURCHASECOMPLETED",
  "Include",
  "In stock",
  "REFUND_GIFT_CARD_SUCCESS",
  "REFUND_BONUS_SUCCESS",
  "REFUND_PAYMENT_SUCCESS",
  "CANCEL_GIFT_CARD_SUCCESS",
  "CANCEL_BONUS_SUCCESS",
  "CANCEL_PAYMENT_SUCCESS",
  "CAPTURE_PAYMENT_SUCCESS",
  "COMPENSATION_PAYMENT_SUCCESS",
  "COMPENSATION_BONUS_SUCCESS",
  "COMPENSATION_GIFT_CARD_SUCCESS",
  "REDEEM_BONUS_SUCCESS",
  "REDEEM_GIFT_CARD_SUCCESS",
  "TRACK_SHIPMENT_SUCCESS",
  "RELEASE_PAYMENT_SUCCESS",
  "RELEASE_BONUS_SUCCESS",
  "RELEASE_GIFT_CARD_SUCCESS",
  "MODIFY_ORDER_LINES_PAYMENT_SUCCESS",
  "MODIFY_SHIPPING_FEES_PAYMENT_SUCCESS",
  "Delivered",
  "Refunded",
  "Compensated",
  "Released",
  "SKIPPED",
  "MANUAL",
  "Placed",
  "Included",
  "CREATED",
  "Updated",
  "Created",
  "External",
  "REPORT_TAX_SUCCESS",
  "REFUND_TAX_SUCCESS"
])

const waitingStatuses = new Set([
  "RUNNING",
  "Change password",
  "Refunded in part",
  "Delivered in part",
  "Compensated in part",
  "NOT CONFIRMED",
  "forced",
  "REPORT_TAX_REQUEST",
  "REFUND_TAX_REQUEST"
])

const errorStatuses = new Set([
  "ERROR",
  "Error",
  "REDEEM_FAILED",
  "Yes",
  "NOT ACTIVE",
  "Inactive",
  "RESERVATION_FAILED",
  "ARCHIVED",
  "ABORTED",
  "DISABLED",
  "Disabled",
  "Not verified",
  "Not provided",
  "Not required",
  "refused",
  "Refused",
  "Exclude",
  "Out of stock",
  "Missing stock data",
  "REFUND_BONUS_FAILURE",
  "REFUND_GIFT_CARD_FAILURE",
  "REFUND_PAYMENT_FAILURE",
  "CANCEL_BONUS_FAILURE",
  "CANCEL_GIFT_CARD_FAILURE",
  "CANCEL_PAYMENT_FAILURE",
  "CAPTURE_PAYMENT_FAILURE",
  "COMPENSATION_PAYMENT_FAILURE",
  "COMPENSATION_GIFT_CARD_FAILURE",
  "COMPENSATION_BONUS_FAILURE",
  "TRACK_SHIPMENT_FAILURE",
  "REDEEM_GIFT_CARD_FAILURE",
  "REDEEM_BONUS_FAILURE",
  "RELEASE_PAYMENT_FAILURE",
  "RELEASE_BONUS_FAILURE",
  "RELEASE_GIFT_CARD_FAILURE",
  "MODIFY_ORDER_LINES_PAYMENT_FAILURE",
  "MODIFY_SHIPPING_FEES_PAYMENT_FAILURE",
  "Cancelled",
  "Failed",
  "Deleted",
  "REPORT_TAX_FAILURE",
  "REFUND_TAX_FAILURE"
])

const Status = ({ status }: Props) => {
  if (successStatuses.has(status)) return <Success>{status}</Success>
  if (waitingStatuses.has(status)) return <Waiting>{status}</Waiting>
  if (errorStatuses.has(status)) return <Error>{status}</Error>
  return <Default>{status}</Default>
}

export default Status
